<template>
    <div class="view view-checkout">
        <top-bar-sub-entel/>
        <div class="site-content" v-show="isVisible">
            <div class="container">
                <div
                    :class="'col-md-6'"
                    :style="{
                    'max-width': '500px' ,
                    'margin':'auto'
                    }"
                >
                    <h2 class="checkout-title checkout-title-primary">ACCEDE A ESTE CONTENIDO</h2>
                    <div
                        class="checkout-card"
                        @click=""
                    >
                        <div class="checkout-card-image">
                            <img
                                :src="require('@/assets/galerias/foto_generica.jpg')"
                                alt
                            />
                        </div>
                        <div class="checkout-card-info">
                            <div class="d-flex justify-content-between">
                                <div style="margin-top: 10px;">
                                    <div
                                        style="text-align:left"
                                    >
                                        <div
                                            class="checkout-card-autor"
                                            style="font-size: 20px;"
                                        >
                                            Educación y Entretenimiento
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-top: 10px;">
                                    <div
                                        style="text-align:right"
                                    >
                                        <div
                                            class="checkout-card-autor"
                                            style="font-size: 20px;"
                                        >
                                            $990
                                        </div>
                                        <div class="checkout-card-titulo">Cobro semanal y renovable.</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <form @submit.prevent="entelSubscribe"
                          ref="registro-form-form"
                          :class="{'validated': validated}"
                          novalidate
                          :style="{
                            'max-width':'470px',
                            'margin':'auto',
                            'margin-top':'20px'}">
                        <div v-if="!cuentaCreada">
                            <div class="form-group">
                                <label for="registro-form-email">Número de teléfono</label>
                                <input

                                    type="number"
                                    :disabled="disabledInput == 1"
                                    :class="{
                                'form-control': true,
                                'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                'is-valid': validated && isTelefonoValid && telefono != ''
                            }"
                                    name="email"
                                    id="registro-form-telefono-landing"
                                    aria-describedby="telefonoHelp"
                                    placeholder="Número de teléfono Ej: 912345678"
                                    autocomplete="off"
                                    v-model="telefono"
                                    required
                                />
                                <div class="invalid-feedback">Teléfono inválido</div>
                                <div class="valid-feedback" v-if="validated"></div>
                            </div>

                            <div class="text-center"
                                 v-if="!isSubmitting">
                                <button
                                    class="btn btn-primary checkout-pay btn-big gtm-registro-header"
                                    style="max-width:100%"
                                    :disabled="suscrib">
                                    <img :src="require('@/assets/images/icon-bag.svg')" alt/>
                                    Suscribirse
                                </button>
                            </div>
                            <br/>
                            <div class="perfil-alert color-red" v-if="alert.visible">
                                <font-awesome-icon
                                    :icon="alert.icon"
                                    class="color-red"
                                    :class="{
                        spin: alert.iconSpin
                    }"
                                />
                                {{ alert.message }}
                            </div>
                        </div>
                        <div v-else class="text-center alert-text-box">
                            <p>Activa tu cuenta desde el link que hemos enviado a tu correo</p>
                        </div>
                    </form>
                    <div class="text-center"
                         v-if="isSubmitting">
                        <button
                            class="btn btn-primary checkout-pay btn-big gtm-registro-header"
                            style="max-width:100%"
                            @click="entelConfirmar">
                            <img :src="require('@/assets/images/icon-bag.svg')" alt/>
                            Confirmar Suscripción
                        </button>
                    </div>
                    <div class="text-center">
                        <label><b style="font-weight: 900">Precio $990 (IVA Incl.)</b><br>Renovación automática semanal.</label>
                        <br>
                        <label><b style="font-weight: 900">Importante:</b>  La suscripción a este
                            servicio representa un cobro
                            adicional con cargo a tu boleta o
                            saldo Entel.</label>
                        <br>
                        <br>
                        <label>Para desuscribir, envía SALIR al 2488</label>
                        <br>
                        <a style="font-size: medium" @click="condiciones"><u><b>Términos y Condiciones</b></u></a>
                        <br>
                    </div>

                    <!--                    <header
                                            class="curso-clases-header transparente-borde"
                                            style="padding:2%;"
                                        >
                                            <div class="curso-clases-descripcion text-justify texto" style="font-size:10px">
                                                <div
                                                    class="texto"
                                                    v-html="descripcion_operador"
                                                ></div>
                                            </div>
                                        </header>-->
                </div>
            </div>
        </div>
        <b-modal v-model="modalPinInputPin"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="Algo">
            <div class="form-group text-center">
                <div class="checkout-card-image">
                    <img
                        :src="require('@/assets/galerias/foto_generica.jpg')"
                        alt
                    />
                </div>
                <br>
                <label class="label-movistar">Te enviamos un mensaje <b>SMS a tu número +{{telefono}}</b> con un <b>Código PIN</b> para que puedas confirmar tu suscripción</label>
                <br>
                <label class="label-movistar"></label>
                <div class="row">
                    <div class="form form-input">
                        <div class="form-group">
                            <input
                                v-model="pin"
                                class="form-control text-center center-input"
                                type="text"
                                maxlength="12"
                                placeholder="Ingresar Código PIN"
                                ref="pin"
                            />
                        </div>

                        <div class="col">
                            <button
                                :class="'btn btn-primary checkout-pay '"
                                style="border-radius: 8px"
                                @click="entelConfirmar">
                                <b style="color: white">CONFIRMAR SUSCRIPCIÓN</b>
                            </button>
                        </div>
                        <br/>
                        <div
                            class="text-center alert-text-box"
                            :class="{
                         'color-red': !colorMensajePin ,
                         'color-green': colorMensajePin
                         }"
                            v-if="pinMessage != ''"
                        >{{ pinMessage }}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modalFelicitaciones"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="Algo">
            <div class="form-group text-center">
                <div class="checkout-card-image">
                    <img
                        :src="require('@/assets/galerias/foto_generica.jpg')"
                        alt
                    />
                </div>
                <br>
                <label class="label-movistar">Muchas gracias por su registro, en un momento sera redireccionado.</label>
                <br>
                <label class="label-movistar"></label>
            </div>
        </b-modal>
        <b-modal v-model="modalCondiciones"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="Algo">
            <div class="form-group text-center">
                <h2><u><b>Términos y Condiciones</b></u></h2>
                <br>
                <label class="label-movistar">El valor de la suscripción o servicio
                    contratado, será cobrado en la boleta
                    Entel correspondiente al periodo de
                    consumo y de forma adicional al cargo
                    fijo del plan. En caso de clientes prepago,
                    el valor se descontará inmediatamente
                    del saldo disponible.</label>
                <br>
            </div>
        </b-modal>
        <b-modal v-model="modalMomento"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="Suscribirse">
            <div class="form-group text-center">
                <br>
                <label class="label-movistar">Cargando.</label>
                <br>
            </div>
        </b-modal>
        <b-modal v-model="modalError"
                 :busy="true"
                 centered
                 hide-footer>
            <div class="form-group text-center">
                <br>
                <div style="text-align: center">
                    <img
                        :src="require('@/assets/errores/003.png')"
                        alt
                    />
                </div>
                <br>
                <div
                    class="label-movistar"
                    v-html="mensajeError"
                ></div>
                <br>
                <br>
                <div class="col">
                    <button
                        v-if="errorDesbloqueo"
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="entelDesbloqueo">
                        <b style="color: white">DESBLOQUEAR CATEGORÍA</b>
                    </button>
                </div>
                <div class="col">
                    <button
                        v-if="errorBoton"
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="cerrar">
                        <b style="color: white">{{ textoBoton }}</b>
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modalErrorExt"
                 :busy="true"
                 centered
                 hide-footer>
            <div class="form-group text-center">
                <br>
                <div style="text-align: center">
                    <img
                        :src="require('@/assets/errores/003.png')"
                        alt
                    />
                </div>
                <br>
                <div
                    class="label-movistar"
                    v-html="mensajeError"
                ></div>
                <br>
                <br>
                <div class="col">
                    <button
                        v-if="errorBotonVuelInt"
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="vuelveIntentar">
                        <b style="color: white">{{ textoBoton }}</b>
                    </button>
                </div>
                <div class="col">
                    <button
                        v-if="errorBotonObtCod"
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="cerrar">
                        <b style="color: white">{{ textoBoton }}</b>
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modalErrorEntelInfo"
                 :busy="true"
                 centered
                 hide-footer>
            <div class="form-group text-center">
                <br>
                <br>
                <div
                    class="label-movistar"
                    v-html="mensajeError"
                ></div>
                <br>
            </div>
        </b-modal>
    </div>

</template>
<style scoped>
body {
    background-color: white;
}
</style>
<script>
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import TransferenciaForm from "../components/TransferenciaForm";
import CencosudForm from "../components/CencosudForm";
import TopBar from "../components/TopBar";
import TopBarSubEntel from "../components/TopBarSubEntel.vue";
import TopBarSubEntelEsp from "../components/TopBarSubEntelEsp.vue";
import SiteFooter from "../components/SiteFooter";
import Spinner from "../components/Spinner";
import {isValidEmail, isValidTelefono, rutEsValido} from "../utilities/util";
import BlockStatic from "../components/BlockStatic";
import numeral from "numeral";
import "numeral/locales";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
numeral.locale("es");
import axios from 'axios';

export default {
    name: "LpEntel",
    components: {
        TopBar,
        TopBarSubEntel,
        TopBarSubEntelEsp,
        bModal,
        TransferenciaForm,
        CencosudForm,
        SiteFooter,
        Spinner,
        BlockStatic,
        FontAwesomeIcon,
    },
    directives: {
        "b-modal": bModalDirective,
    },
    computed: {
        isTelefonoValid() {
            if (this.telefono.length == 9) {
                return isValidTelefono(this.telefono.toString());
            }else {
                return false;
            }
        },
    },
    watch: {

    },
    data() {
        return {
            visibleSuscribirFe: 0,
            imagen: require('@/assets/galerias/video.png'),
            vistaEsp: false,
            modalCondiciones: false,
            suscrib: false,
            empello: "",
            errorBotonVuelInt: false,
            errorBotonObtCod: false,
            producto: "",
            disabledInput: 0,
            disabledForm: 1,
            visibleInput: 1,
            prepago: false,
            pospago: false,
            modalMomento: false,
            inscriptionId: "",
            pinMessage: "",
            colorMensajePin: false,
            pin: "",
            modalPinInputPin: false,
            modalError: false,
            descripcion_operador: "",
            descripcion: "Aca va la descripcion del curso",
            isVisible: false,
            validated: false,
            isSubmitting: false,
            cuentaCreada: false,
            telefono: JSON.parse(window.sessionStorage.getItem('telefono')),
            telefono_suscribir: "",
            alert: {
                message: "",
                visible: false,
                icon: "",
                iconSpin: false,
            },
            productId: this.$route.params.productId,
            tid: "",
            fe: this.$route.query.fe,
            entryChannel: "",
            service_ip_entel: "",
            modalFelicitaciones: false,
            mensajeError: "",
            statusError: "",
            msisdn: "",
            ip: "",
            schar: "",
            errorBoton: false,
            errorDesbloqueo: false,
            textoBoton: "",
            modalErrorEntelInfo: false,
            paramenviar: "",
        };
    },
    methods: {
        play(){
            this.visibleSuscribirFe = 2;
        },
        playImg(){
            this.visibleSuscribirFe = 2;
        },
        condiciones(){
            this.modalCondiciones = true;
        },
        cerrar(){
            this.suscrib = false;
            this.textoBoton = "";
            this.mensajeError = "";
            this.isSubmitting = false;
            this.validated = false;
            this.modalError = false;
            this.modalPinInputPin = false;
            this.errorBoton = false;
            this.errorDesbloqueo = false;
            this.modalErrorExt = false;
            if (this.telefono !== "") {
                this.disabledInput = 1;
            }
        },
        activarSuscribirFe(){
            this.visibleSuscribirFe = 2;
        },
        vuelveIntentar(){
            this.modalErrorExt = false;
            if (this.entryChannel === "WEB") {
                this.modalPinInputPin = true;
            }
        },
        async entelInfo(){
            await this.$api
                .entelInfo({
                    userIdentifier: this.telefono,
                    productId: this.productId,
                })
                .then((response) => {
                    if (response.data.dailyCap === true || response.data.error === false) {
                        this.modalErrorEntelInfo = true;
                        setTimeout(() => {
                            this.modalErrorEntelInfo = false;
                        }, 3000);
                    } else {
                        if (response.data.planType === "0" && response.data.error === true) {
                            this.prepago = true;
                            this.descripcion_operador = "Precio $990 (IVA Incl.) renovación automática semanal. Servicio de suscripción con renovación automática. Precio con cobro al saldo disponible, se aplica mientras no se cancele suscripción. Para cancelar envía SALIR al 2488. Revisar Términos y Condiciones aqui"
                        } else if (response.data.planType !== "0" || (response.data.error === true && response.data.planType === "" && response.data.dailyCap === "")) {
                            this.pospago = true;
                            this.descripcion_operador = "Precio $990 (IVA Incl.) renovación automática semanal. Servicio de suscripción con renovación automática. Precio con cobro adicional al cargo fijo del plan, se aplica mientras no se cancele suscripción. Para cancelar envía SALIR al 2488. Revisar Términos y Condiciones aqui"
                        }
                    }
                });
        },
        async headerReq1(){
            this.msisdn =this.$route.query.msisdn;
            this.ip = this.$route.query.ip;
            this.schar = this.$route.query.schar;
            await this.$api
                .hearderReq1({
                    msisdn: this.msisdn,
                    ip: this.ip,
                    schar: this.schar,
                })
                .then((response) => {
                    if (response.data.message === "success") {
                        this.telefono = response.data.msisdn;
                        this.visibleSuscribirFe = 1;
                        if (this.productId === "1000007096")
                            this.vistaEsp = true;
                        this.inscribedByMobile()
                        this.modalMomento = false;
                    } else {
                        this.visibleSuscribirFe = 1;
                        if (this.fe) {
                            this.visibleInput = 0;
                        }
                        if (this.productId === "1000007096")
                            this.vistaEsp = true;
                        if (!this.fe)
                            this.disabledForm = 1;
                        this.isVisible = true;
                        this.prepago = true;
                        this.descripcion_operador = "Precio $990 (IVA Incl.) renovación automática semanal. Servicio de suscripción con renovación automática. Precio con cobro adicional al cargo fijo del plan o contra el saldo disponible, se aplica mientras no se cancele suscripción. Para cancelar envía SALIR al 2488. Revisar Términos y Condiciones aqui";
                        this.entryChannel = "WEB";
                        this.modalMomento = false;
                    }
                });
        },
        hearderReqDatos(){
            this.$api
                .hearderReqDatos()
                .then((response) => {
                    if (response.data.msisdn !== "") {
                        window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&msisdn=" + response.data.msisdn + "&ip=" + response.data.ip + "&schar=" + response.data.schar + "&status=1";
                    }else {
                        if (this.fe){
                            window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe+ "&status=1";
                        }else {
                            window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&status=1";
                        }
                    }
                });
        },
        async datosProducto(){
            await this.$api
                .datosProducto({productId: this.productId})
                .then((response) => {
                    if (response.data.success === true) {
                        this.producto = response.data.producto;
                        this.empello = response.data.empello;
                        //Agregando EMPELLO FRAUDSTOOP
                        let empelloFraudStop = document.createElement("script");
                        empelloFraudStop.setAttribute(
                            "src",
                            "//" + this.empello
                        );
                        document.head.appendChild(empelloFraudStop);
                    }
                });
        },
        entelConfirmar(){
            this.errorDesbloqueo = false;
            this.pinMessage = "";
            this.$log.warn('Entel Confirmar');
            this.$api
                .entelConfirmar({
                    entryChannel: (this.entryChannel === "WAP" ? this.entryChannel : this.entryChannel = "WEB"),
                    inscriptionId: this.inscriptionId,
                    pin: this.pin,
                })
                .then((response) => {
                    if (response.data.success ===true && (response.data.status === 201 || response.data.status === 200)){
                        if (this.productId === "1000007096"){
                            this.$router.push({
                                name: "LpEntelFelicitaciones",
                                params: {
                                    msisdn: "56" + this.telefono,
                                }
                            });
                            //window.location.href = "/felicitaciones/lp/entel?msisdn=56"+ this.telefono
                        }else {
                            this.modalFelicitaciones = true;
                            setTimeout(() => {
                                this.proxyUser();
                            }, 4000);
                        }
                    }else if(response.data.status === 1 || response.data.status === 2){
                        this.modalPinInputPin = false;
                        this.errorDesbloqueo =true;
                        this.mensajeError = response.data.message;
                        this.modalError = true;
                    }else if (response.data.status === 3 || response.data.status === 11){
                        this.modalPinInputPin = false;
                        this.errorBoton = false;
                        this.mensajeError = response.data.message;
                        this.modalError = true;
                    }else if (response.data.status === 15){
                        this.textoBoton = "OBTENER NUEVO CÓDIGO";
                        this.modalErrorExt = true;
                        this.errorBotonObtCod = true;
                        this.errorBotonVuelInt = false;
                        this.modalPinInputPin = false;
                        this.mensajeError = response.data.message;
                    }else {
                        this.textoBoton = "CERRAR";
                        this.mensajeError = response.data.message;
                        this.modalError = true;
                        this.errorBoton = true;
                        this.modalPinInputPin = false;
                    }
                });
        },
        entelDesbloqueo(){
            this.$api
                .entelDesbloqueo({
                    inscriptionId: this.inscriptionId,
                })
                .then((response) => {
                    if (response.data.status === 200){
                        this.disabledInput =1;
                        this.modalError = false;
                        this.suscrib = false;
                    }else {
                        this.suscrib = false;
                        this.errorDesbloqueo = false;
                        this.mensajeError = response.data.message;
                        this.telefono ="";
                    }
                });
        },
        inscribedByMobile(){
            this.$api
                .inscribedByMobile({
                    mobile: this.telefono,
                })
                .then((response) => {
                    if (response.data[0]){
                        this.telefono = this.telefono.substring(2,11);
                        this.proxyUser()
                    }else {
                        this.isVisible = true;
                        window.sessionStorage.setItem('telefono', JSON.stringify(this.telefono));
                        this.telefono = this.telefono.substring(2,11);
                        this.disabledInput = 1;
                        this.disabledForm = 1;
                        this.entelInfo();
                        this.entryChannel = "WAP";
                    }
                });
        },
        async entelSubscribe(){
            if (this.entryChannel === "WEB" && this.productId === "1000007096" && !this.fe){
                this.$api
                    .true_or_false()
                    .then((response) => {
                        if (response.data.valor === 1){
                            window.location.href = "https://suscripciones.multinetlabs.com/suscripciones-ws/rest/util/proxy_pass?hash="+ this.tid
                        }
                    });
            }else {
                if (!this.fe) {
                    this.visibleSuscribirFe = 3;
                }
                this.validated = true;
                this.errorDesbloqueo = false;
                let empelloToken = "";
                empelloToken = await this.getEmepelloToken();
                if (this.isTelefonoValid && this.telefono != '') {
                    await this.$api
                        .entelSubscribe({
                            empelloToken: empelloToken,
                            productId: this.productId,
                            tid: this.tid,
                            telefono: this.telefono,
                            entryChannel: (this.entryChannel === "WAP" ? this.entryChannel : this.entryChannel = "WEB"),
                        })
                        .then((response) => {
                            this.inscriptionId = response.data.inscriptionId;
                            if (response.data.success === true && response.data.status === 200) {
                                if (this.entryChannel !== "WAP") {
                                    this.suscrib = true;
                                    this.modalPinInputPin = true;
                                } else {
                                    this.suscrib = true;
                                    this.isSubmitting = true;
                                }
                            } else if (response.data.status === 1 || response.data.status === 2) {
                                this.errorDesbloqueo = true;
                                this.mensajeError = response.data.message;
                                this.modalError = true;
                            } else if (response.data.status === 3) {
                                this.errorBoton = false;
                                this.mensajeError = response.data.message;
                                this.modalError = true;
                            } else if (response.data.status === 15) {
                                this.textoBoton = "OBTENER NUEVO CÓDIGO";
                                this.modalErrorExt = true;
                                this.errorBotonObtCod = true;
                                this.errorBotonVuelInt = false;
                                this.mensajeError = response.data.message;
                            } else {
                                this.textoBoton = "CERRAR";
                                this.errorBoton = true;
                                this.mensajeError = response.data.message;
                                this.modalError = true;
                            }
                        });
                }
            }
        },
        proxyUser(){
            window.location.href = "https://cms.topclass.academy/thinkific/auth?msisdn=56"+ this.telefono
        },
        getEmepelloToken() {
            return new Promise((resolve, reject) => {
                Empello.getToken(function (token) {
                    resolve(token);
                });
            });
        },
        async proxyNotification() {
            this.paramenviar = window.location.search;
            await this.$api
                .proxyNotification({
                    paramenviar: this.paramenviar,
                })
                .then((response) => {
                    if (response.data.tid) {
                        this.tid = response.data.tid;
                        /*if (this.fe){
                            window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe;
                        }else {
                            window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid;
                        }*/
                        if (location.protocol === 'https:'){
                            this.$log.warn('Redireccionando a http');
                            if (this.fe){
                                window.location.href = "http://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe;
                            }else {
                                window.location.href = "http://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid;
                            }
                        }
                    }
                });
        },
    },
    mounted() {
        if (this.$route.query.status === "1"){
            this.datosProducto();
            this.modalMomento = true;
            this.headerReq1();
        }
    },
    created() {
        if (this.productId === "1000007096" && this.$route.query.operador) {
            this.proxyNotification();
        }else {
            this.tid = this.$route.query.tid;
            if (location.protocol === 'https:'){
                if (this.$route.query.status !== "1"){
                    if (this.fe){
                        window.location.href = "http://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe;
                    }else {
                        window.location.href = "http://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid;
                    }
                }
            }else {
                this.modalMomento = true;
                this.hearderReqDatos();
            }
        }
        /*if (this.productId === "1000007096" && this.$route.query.operador) {
            this.proxyNotification();
        }else {
            this.tid = this.$route.query.tid;
            if (this.$route.query.status !== "1"){
                if (location.protocol === 'https:'){
                    if (this.fe){
                        window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe;
                    }else {
                        window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid;
                    }
                }
                this.hearderReqDatos();
            }
        }*/
    },
};
</script>
